import React, {Component, PropTypes} from 'react';

import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {sortBy, filter, map, first} from 'lodash';
import styles from 'src/components/Catalog/Catalog.scss';
import Media from 'react-responsive';
import SortLabel from 'src/components/SortLabel/SortLabel';
import {isDesktop} from 'src/logic/utils';
import config from '../../../config';
import * as actions from 'src/redux/catalogActions';
import carImg from 'src/imgs/car/default-car.jpg';
import {Link} from 'react-router';
import {Row} from 'src/components/Common/reactstrap/lib';


export class GarageCatalog extends Component {
  constructor(props, context) {
    super(props, context);
    props.getModels(props.params.brand);
  }

  render() {
    // var showCarInMobile = false;
    const brand = this.props.brand;
    const brandCatalog = sortBy(this.props.modelList, ['modelName', 'modelYearStart']);
    const mobileBrandCatalog = (generationName) => filter(brandCatalog, function (item) {
      return item.generationName === generationName;
    });


    const items = (catalog) => map(catalog, (item, i, itemList) => {
      let title = item.generationName.length > 40 ? (item.generationName.slice(0, 30) + '...') : item.generationName;
      const modelName = itemList[i - 1] && itemList[i - 1].modelName === itemList[i].modelName
        ? '' : item.modelName;
      const garageLink = config.routes.garage;
      const href = `${garageLink}/${brand.brandId}/${item.modelId}`;

      return (
        <div className={styles.car_container}>
          <strong className={styles.modelName}>{modelName || undefined}</strong>
          <Link
            to={href}
            className="link"
          >
            <img className={styles.responsive_img} src={item.imgUrl} onError={(e) => e.target.src = carImg}/>
          </Link>
          <span>
          <Link
            to={href}
            className="link"
          >
            {brand.brandName + ' ' + title}
          </Link>
        </span>
          <span
            className={styles.release_date}>{item.modelYearStart + ' - '}{item.modelYearEnd ? (item.modelYearEnd) : 'наст. время'}</span>
        </div>
      );
    });


    return (
      <div className={styles.Catalog}>
        <div className={styles.back_link}>
          <i className={styles.leftArrow}>&larr; </i>
        <button className="btn btn-link" onClick={() => window.history.back()}>Вернуться назад</button>
        </div>
          <div className={styles.flex_table_container}>
            <Row>{ items(brandCatalog)}</Row>
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    ...state.catalogReducer,
    brandList: state.categoriesReducer.brandList
  }),
  (dispatch) => ({...bindActionCreators(actions, dispatch)})
)(GarageCatalog);











/** WEBPACK FOOTER **
 ** ./src/components/User/elements/GarageCatalog.jsx
 **/